import { render, staticRenderFns } from "./PopularIntroduction.vue?vue&type=template&id=6dc0bcb4&scoped=true&"
import script from "./PopularIntroduction.vue?vue&type=script&lang=js&"
export * from "./PopularIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./PopularIntroduction.vue?vue&type=style&index=0&id=6dc0bcb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0bcb4",
  null
  
)

export default component.exports